// app/providers.tsx
"use client"

import posthog from "posthog-js"
import { PostHogProvider as PHProvider } from "posthog-js/react"
import { useEffect } from "react"

export function PostHogProvider({ children }: { children: React.ReactNode }) {
   useEffect(() => {
      const isDisabled = process.env.POSTHOG_DISABLED === "true" || process.env.NEXT_PUBLIC_POSTHOG_DISABLED === "true"

      if (isDisabled) return
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY ?? process.env.POSTHOG_KEY ?? "", {
         api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST ?? process.env.POSTHOG_HOST,
         defaults: "2025-05-24",
      })
      // posthog.debug(true) // Enable debug for detailed logs
   }, [])

   return <PHProvider client={posthog}>{children}</PHProvider>
}
